
import { Component, Prop, toNative, Vue } from 'vue-facing-decorator';
import { MultimediaItem } from '@/entities/Program/MultimediaItem';
import loading from '@/components/Common/loading.vue';
import { FetchData, Root } from '@/main';
import useVuelidate from '@vuelidate/core';
import { required, minLength } from '@vuelidate/validators';
import { reactive } from 'vue';
@Component({
  components: {
    loading,
  },
})
class ProgramMultimediaEditItemPane extends Vue {
  @Prop() private selectedMultimediaItem?: MultimediaItem;
  @Prop() private applicationborderColor?: string;
  @Prop() private selectedProgramId?: number;
  public showLoading = false;
  public loaderBorderColor = '';
  private missingImage: string = require('@/assets/Images/ImageMissing.png');
  private showImageProcess = false;
  public localMultimediaItem: MultimediaItem | null = null;
  private state = reactive({
    localMultimediaItem: null as MultimediaItem | null,
  });

  private rules = {
    localMultimediaItem: {
      Title: {
        required,
        minLength: minLength(1),
      },
      ThumbUrl: {
        required,
      },
    },
  };
  private status(validation: { $error: any; $dirty: any }) {
    return {
      error: validation.$error,
      dirty: validation.$dirty,
    };
  }
  private v$ = useVuelidate(this.rules, this.state);
  private Cancel(val: any) {
    val.$reset();
    // update full image src in selectedMultimedia item for cancel operation
    this.selectedMultimediaItem!.Url = this.selectedMultimediaItem!.OldUrl;
    this.selectedMultimediaItem!.ThumbUrl = this.selectedMultimediaItem!.OldThumbUrl;
    this.selectedMultimediaItem!.Title = this.selectedMultimediaItem!.OldTitle;
    this.$emit(
      'program-multimedia-item-cancel-operation',
      this.selectedMultimediaItem,
    );
  }

  private clickOnImage(val: boolean) {
    // retain textbox value if switch to image component
    this.selectedMultimediaItem!.Title = this.localMultimediaItem!.Title;
    this.showImageProcess = val;
    this.$emit('program-multimedia-item-imageUpload-operation', val);
  }
  private GetImageUrl() {
    return this.localMultimediaItem!.ThumbUrl === null
      ? this.missingImage
      : this.localMultimediaItem!.ThumbUrl === ''
        ? this.missingImage
        : this.localMultimediaItem!.ThumbUrl;
  }
  private created() {
    if (this.selectedMultimediaItem != null) {
      this.localMultimediaItem = MultimediaItem.createEmpty();
      // to retain values for cancel operation
      if (
        this.selectedMultimediaItem.OldUrl === '' ||
        this.selectedMultimediaItem.OldUrl == null
      ) {
        this.selectedMultimediaItem.OldUrl = this.selectedMultimediaItem.Url;
        this.selectedMultimediaItem.OldThumbUrl = this.selectedMultimediaItem.ThumbUrl;
        this.selectedMultimediaItem.OldTitle = this.selectedMultimediaItem.Title;
      }

      this.localMultimediaItem = Object.assign(
        this.localMultimediaItem,
        this.selectedMultimediaItem,
      );
      this.state.localMultimediaItem = this.localMultimediaItem;
    }
  }

  private async Submit(val: any) {
    val.$touch();
    const res = !await val.$validate();
    if(res) {
      return;
    }
    val.$reset();
    // No errors submitting.
    if (this.applicationborderColor != null) {
      this.loaderBorderColor = this.applicationborderColor;
    }
    FetchData('/Program/EditProgramMedia',
      JSON.stringify(this.localMultimediaItem))
      .then((response) => {
        if (response.ValidationErrors.length > 0) {
          // Server side validation failuere
          alert(this.$t(response.ValidationErrors[0]));
        } else {
          // need information send to signalr
          const multimediaItemData = {
            dataItem: response.MultimediaItem,
            programDetailType: 'Multimedia',
          };
          Root.emit('multimedia-update-signalr', multimediaItemData);

          this.$emit(
            'program-multimedia-item-edit-operation',
            response.MultimediaItem,
          );
          Root.emit(
            'program-multimedia-item-edit-operation',
            response.MultimediaItem,
          );
        }
      })
      .catch(() => {
        // Log error if required
      });
  }
}
export default toNative(ProgramMultimediaEditItemPane);
